export default __webpack_public_path__ + "static/media/habilitar-permiso-camara-android-4.fa39e2b3.svg";